import React from 'react'
import { Container } from 'react-bootstrap';
import LeftHeading from '../../../../Components/Accounts/LeftHeading/LeftHeading';
import Section from '../../../../Components/Section/Section'
import MultiItemsGrid from '../../../../Components/Accounts/MultiItemsGrid/MultiItemsGrid';
import '../../../../Components/Accounts/Orders.css'
import OrderBasicDetails from '../../../../Components/Accounts/OrderBasicDetails/OrderBasicDetails';
import { getResponseError, getUserDetailsCookie } from '../../../../Api/Utils/apiUtils';
import BusinessDetailsApi from '../../../../Api/BusinessDetailsApi';
import SupplierPaymentApi from '../../../../Api/SupplierPaymentApi';
import ErrorAlert from '../../../../Components/Form/ErrorAlert/ErrorAlert';
import SpecificPersonOrder from '../../../../Components/Accounts/SpecificPersonOrder/SpecificPersonOrder';
import { createChatRoom } from '../../../../Api/Utils/chatUtils';
import { useHistory } from "react-router-dom";




const ManageOrderComponent = () => {
    const history = useHistory();
    const [errorMessage, setErrorMessage] = React.useState(null);
    const [orders, setorders] = React.useState([])
    const [businessdetails, setbusinessdetails] = React.useState(null);


    const messageWithTheCustomer = (person) => {
        const setupMessage = {
            mBuyerImage: person.imageUrl,
            mBuyerName: `${person.firstName} ${person.lastName}`,
            mSupplierImage: businessdetails.businessLogo && businessdetails.businessLogo.imageUrl,
            mSupplierName: businessdetails.businessName,
            mSupplierPlayerId: "",
            mBuyerPlayerId: ""
        }
        createChatRoom(person.userId, businessdetails.userId, setupMessage)
        const loc = {
            pathname: '/messages',
            state: { id: `${person.userId}-${businessdetails.userId}` }
        }
        history.push(loc)
        history.replace(loc)
    }

    React.useEffect(() => {
        const loadOrder = async () => {
            const user = getUserDetailsCookie();
            const userId = user.id;
            const businessDetailsResponse = await BusinessDetailsApi.getBusinessDetails(userId);
            const businessApiError = getResponseError(businessDetailsResponse);
            if (businessApiError) {
                setErrorMessage(businessApiError);
            }else{
                const supplierId = businessDetailsResponse.objectVal.userId;
                setbusinessdetails(businessDetailsResponse.objectVal)
                const response = await SupplierPaymentApi.getOrders(supplierId)
                const OrderApiError = getResponseError(response)
                if (OrderApiError) {
                    setErrorMessage(OrderApiError);
                }else{
                    const orderList = response.objectVal;
                    setorders(orderList)
                }
            }
        }
        loadOrder()
    }, [])
    return (
        <Section contStyle={{minHeight:"400px"}}>
            <Container>
                <LeftHeading>Manage Order</LeftHeading>
                <ErrorAlert>{errorMessage}</ErrorAlert>
                {orders.map((person, index) => (
                <SpecificPersonOrder isSingleProduct={(person.productInformation && person.productInformation.length === 1) ? true : false} personName={`${person.firstName} ${person.lastName}`} key={`PERSON${index}`}>
                    <MultiItemsGrid itemsPerRow={3}>
                        {person.productInformation && 
                            person.productInformation.map((order, key) => (
                            <div className="order-card" key={`ORDER${key}`}>
                                <div className="product-and-buyer-details">
                                    <h4>{order.title && order.title}</h4>
                                    <OrderBasicDetails label="Order ID">{order.id && order.id}</OrderBasicDetails>
                                    <OrderBasicDetails label="Quantity">{order.quantity && order.quantity}</OrderBasicDetails>
                                    <OrderBasicDetails label="Amount" isMoney={true}>{order.price && order.price}</OrderBasicDetails>
                                    <OrderBasicDetails label="Total amount" isMoney={true}>{(order.quantity && order.price) && order.quantity * order.price}</OrderBasicDetails>
                                    <div className="order-manage-option">
                                        <button className="accept">Accept</button>
                                        <button className="decline">Decline</button>
                                        <button onClick={() => messageWithTheCustomer(person)} className="discuss" >Discuss</button>
                                    </div>
                                </div>
                            </div>
                            ))
                        }
                    </MultiItemsGrid>
                </SpecificPersonOrder>
                ))}
            </Container>
        </Section>
    )
}

export default ManageOrderComponent
